// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"334":"669a261380374549","449":"6cc634f80097d4a9","596":"1f3ba5021e628000","608":"088659e042208b5c","765":"6ea9a47eaab3f809","863":"34875686076d844a"}[chunkId] + ".js";
};